import { combineReducers, Reducer, AnyAction, UnknownAction, Action } from 'redux'

import { State } from '@owl-nest/redux-wrapper'

import { Project } from '../public/models/project'

import * as channel from './channel'
import * as comments from './comments'
import * as events from './events'
import * as fandom from './fandom'
import * as faq from './faq'
import * as followModal from './modals/followModal'
import * as impact from './impact'
import * as paymentDisturbanceModal from './modals/paymentDisturbanceModal'
import * as postCampaignModal from './modals/postCampaignModal'
import * as rewardModal from './modals/rewardModal'
import * as shareOverlay from './modals/shareOverlay'
import * as submitModal from './modals/submitModal'
import * as supporter from './supporter'
import * as variantModal from './modals/variantModal'
import { State as ProjectState, reducerMaker } from './project'

export type AppState = {
  channel: channel.State
  comments: comments.State
  events: events.State
  fandom: fandom.State
  faq: faq.State
  followModal: followModal.State
  impact: impact.State
  paymentDisturbanceModal: paymentDisturbanceModal.State
  postCampaingModal: postCampaignModal.State
  project: ProjectState
  rewardModal: rewardModal.State
  shareOverlay: shareOverlay.State
  submitModal: submitModal.State
  supporter: supporter.State
  variantModal: variantModal.State
}

export type RootState = State<AppState>

export const makeReducer = (project: Project) => {
  return combineReducers({
    channel: channel.reducer,
    comments: comments.reducer,
    events: events.reducer,
    fandom: fandom.reducer,
    faq: faq.reducer,
    followModal: followModal.reducer,
    impact: impact.reducer,
    paymentDisturbanceModal: paymentDisturbanceModal.reducer,
    postCampaingModal: postCampaignModal.reducer,
    project: reducerMaker(project),
    rewardModal: rewardModal.reducer,
    shareOverlay: shareOverlay.reducer,
    submitModal: submitModal.reducer,
    supporter: supporter.reducer,
    variantModal: variantModal.reducer,
  })
}
